
























































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import DashboardTemplate from "@/views/Layouts/dashboard-template.vue";
import { MutationTypes } from "@/store/devices/mutations";
import List from "@/components/list.vue";
import SelectionList from "@/components/selection-list.vue";
import { dateFormatter, getCircleColor, getLoraIcon, getWifiIcon } from "@/utils/utils";
import { ActionTypes } from "@/store/devices/actions";
import Map from "@/components/map.vue";
import DeviceInfo from "@/models/deviceInfo.model";
import deviceService from "@/services/device.service";
import profileService from "@/services/profile.service";
import LifetimeChanger from "@/components/lifetime-changer.vue";
import {TagProfile} from "@/models/Profiles/TagProfile.model";
import DeviceService from "@/services/device.service";


@Component({
  components: {
    DashboardTemplate,
    List,
    SelectionList,
    Map,
    LifetimeChanger
  },
})
export default class DeviceInfoPage extends Vue {
  public $refs!: {
    profileTable: any,
    list: any
  };

  private data: any[] = [];
  private locations: any[] = [];
  private profiles: TagProfile[] = [];
  private selectedProfile: TagProfile | null = null;
  private centerLocation: { lat: number, lng: number } | null = null;
  private dialogVisible = false;
  private profileDialogVisible = false;
  private selectedEvent = null;
  private selectedDeviceLabel = "";
  private selectedDeviceLabelHasChanged = false;
  private selectedTag: DeviceInfo | null = null;

  @Watch("selectedDeviceLabel", { deep: true, immediate: true })
  private onDatasetsChanged(oldData: any, newData: any) {
    if (newData && newData !== oldData) {
      this.selectedDeviceLabelHasChanged = true;
    }
  }

  private get lastLocations() {
    const locations = [];

    if (this.selectedTag?.status?.reported.lpwanLocation?.date) {
      locations.push({
        locationType: "Tower",
        locationTime: this.selectedTag?.status?.reported.lpwanLocation?.date,
        accuracy: this.selectedTag?.status?.reported.lpwanLocation?.data.accuracy,
        rawData: this.selectedTag?.status?.reported.lpwanLocation?.data
      });
    }

    if (this.selectedTag?.status?.reported.tdoaLocation?.date) {
      locations.push({
        locationType: "Network location",
        locationTime: this.selectedTag?.status?.reported.tdoaLocation?.date,
        accuracy: this.selectedTag?.status?.reported.tdoaLocation?.data.accuracy,
        rawData: this.selectedTag?.status?.reported.tdoaLocation?.data
      });
    }

    if (this.selectedTag?.status?.reported.wifiLocation?.date) {
      locations.push({
        locationType: "Wifi",
        locationTime: this.selectedTag?.status?.reported.wifiLocation?.date,
        accuracy: this.selectedTag?.status?.reported.wifiLocation?.data.accuracy,
        rawData: this.selectedTag?.status?.reported.wifiLocation?.data
      });
    }

    if (this.selectedTag?.activationInfo && this.selectedTag?.activationInfo?.lat &&
        this.selectedTag?.activationInfo?.lng) {
      locations.push({
        locationType: "Activator App",
        locationTime: this.selectedTag?.activationInfo.locationTime,
        accuracy: this.selectedTag?.activationInfo.accuracy,
        rawData: this.selectedTag?.activationInfo
      });
    }

    return locations;
  }

  private get selectedTagId() {
    return this.$typedStore.getters.selectedDevice?.id;
  }

  private get selectedTagLabel() {
    return this.$typedStore.getters.selectedDevice?.label;
  }

  private get selectedTagStatus() {
    return this.selectedTag?.getStatus().filter((x) => x.property.toLowerCase().indexOf("location") < 0);
  }

  private getLocationTypeName(locationType: string, isTDOALocation: boolean) {
    if (locationType === "WIFI" || locationType == "ACTIVATOR_APP") {
      return locationType;
    } else {
      if (isTDOALocation) {
        return "LPWAN Network Location";
      } else {
        return "LPWAN Tower";
      }
    }
  }

  private async mounted() {
    this.selectedTag = await DeviceService.get(this.$route.params.id);

    this.$typedStore.commit(MutationTypes.SetDeviceToGetInfo, this.$route.params.id);
    this.selectedDeviceLabel = await deviceService.get(this.$route.params.id).then((x) => x.label) ?? "";
    this.locations = (await deviceService.getLastLocations(this.$route.params.id)).map((loc: any) => ({
      ...loc,
      locationType: this.getLocationTypeName(loc.locationType, loc.isTDOALocation)
    }));
    this.profiles = (await profileService.getAvailableProfiles());

    if (this.locations && this.locations.length) {
      this.setMarkers(this.locations);
    }

    this.$nextTick(() => {
      setTimeout(() => {
        const list = (this.$refs.list as any);
        if (list) {
          this.locations.forEach((item, _) => {
            if (item.latitude && item.longitude) {
              list.toggleRowSelection(item, true);
            }
          });
        }
      }, 1_000);
    });
  }

  private setMarkers(items: any[]) {
    this.data = items.map((loc) => ({
      position: {
        lat: loc.latitude,
        lng: loc.longitude,
      },
      locationInfo: {
        updatedAt: loc.locationTime,
        label: this.selectedTag?.label ?? this.$route.params.id,
        id: this.$route.params.id
      },
      center: {
        lat: loc.latitude,
        lng: loc.longitude,
      },
      radius: loc.accuracy ?? 5_000,
      options: {
        fillColor: getCircleColor(loc.locationType === "WIFI" ? 1 : 0),
        strokeColor: getCircleColor(loc.locationType === "WIFI" ? 1 : 0)
      },
      icon: loc.locationType === "WIFI" ? getWifiIcon() : getLoraIcon()
    }));
    if (items.length) {
      const item = items.filter((x) => x.latitude && x.longitude).shift();
      if (item && item.latitude && item.longitude) {
        this.centerLocation = {
          lat: item.latitude,
          lng: item.longitude
        };
      }
    }
  }

  private tableRowClassName(row: any, rowIndex: number) {
    return row !== undefined && row.requestedDate > row.reportedDate;
  }
  private handleProfileSelection(profile: TagProfile) {
    this.selectedProfile = profile;
  }

  private dateFormatter(row: any, column: any) {
    return dateFormatter(row, column);
  }

  private async executeAction(device: DeviceInfo | null, action: ActionTypes, message: string) {
    if (device) {
      if (await this.$typedStore.dispatch(action, device.id)) {
        alert(message);
      } else {
        alert("An error occurred. Please try again.");
      }
    }
  }

  private openDetails(details: any) {
    this.selectedEvent = details;
    this.dialogVisible = true;
  }

  private getReportedLocationTypeData(type: string) {
    return this.selectedTag?.status?.reported[type]?.data;
  }

  private async startRecovery() {
    await this.executeAction(this.selectedTag, ActionTypes.StartRecovery, "Device requested to be in recovery mode");
  }

  private async stopRecovery() {
    await this.executeAction(this.selectedTag, ActionTypes.StopRecovery, "Device requested to be in active mode");
  }

  private async startIdentification() {
    await this.executeAction(this.selectedTag, ActionTypes.StartIdentification, "Request sent to device to enable its identification through the Activator App");
  }

  private async stopIdentification() {
    await this.executeAction(this.selectedTag, ActionTypes.StopIdentification, "Request sent to device to disable its identification through the Activator App");
  }

  private async requestLocation() {
    await this.executeAction(this.selectedTag, ActionTypes.RequestLocation, "Request sent to the device report its location");
  }

  private async requestProfileChange() {
    if (this.selectedProfile && this.selectedTag) {
      await profileService.changeProfile(this.selectedTag?.id ?? "" , this.selectedProfile.id);
    } else {
      this.$notify({
        type: "error",
        title: "Error",
        message: "There was no tag or profile selected, request is canceled."
      });
    }
    this.selectedProfile = null;
    this.$refs.profileTable.setCurrentRow(undefined);
    this.profileDialogVisible = false;
  }
  private async cancelProfileChange() {
    this.selectedProfile = null;
    this.$refs.profileTable.setCurrentRow(undefined);
    this.profileDialogVisible = false;
  }

  private async updateTagLabel() {
    if (this.selectedDeviceLabel !== this.selectedTag?.label) {
      await this.$typedStore.dispatch(ActionTypes.UpdateDeviceLabel,
          { serialNumber: this.selectedTag?.id ?? "", label: this.selectedDeviceLabel });
      this.selectedDeviceLabelHasChanged = false;
    }
  }

  private async lifetimeChanged(lifetime: number) {
    const reportedLifetime = this.selectedTag?.status?.reported?.lifetime?.data;
    if (reportedLifetime !== lifetime * 365) {
      if (await this.$typedStore.dispatch(ActionTypes.ChangeLifetime, {device: this.selectedTag?.id, lifetime})) {
        alert("Request sent to change the lifetime of the device");
      } else {
        alert("An error occurred. Please try again.");
      }
    }
  }

  private handleSelectionChange(val: any[]) {
    this.setMarkers(val);
  }

  private formatRowClass({row, rowIndex}: { row: any, rowIndex: number }) {
    const lpwanLocation = this.getReportedLocationTypeData("lpwanLocation");
    const tdoaLocation = this.getReportedLocationTypeData("tdoaLocation");
    const wifiLocation = this.getReportedLocationTypeData("wifiLocation");
    const info = [];
    if (lpwanLocation) {
      info.push({
        latitude: lpwanLocation.lat,
        longitude: lpwanLocation.lng,
        accuracy: lpwanLocation.accuracy,
        locationTime: lpwanLocation.locationTime
      });
    }
    if (tdoaLocation) {
      info.push({
        latitude: tdoaLocation.lat,
        longitude: tdoaLocation.lng,
        accuracy: tdoaLocation.accuracy,
        locationTime: tdoaLocation.locationTime
      });
    }
    if (wifiLocation) {
      info.push({
        latitude: wifiLocation.lat,
        longitude: wifiLocation.lng,
        accuracy: wifiLocation.accuracy,
        locationTime: wifiLocation.locationTime
      });
    }

    if (info.find((i) =>
        i.latitude === row.latitude &&
        i.longitude === row.longitude &&
        i.accuracy === row.accuracy &&
        i.locationTime === row.locationTime)) {
      return "row-info";
    }
    return "";
  }
}
